module.exports = __webpack_public_path__ + "img/25.a4fd97b5.svg";